import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  addWebhookEndpoint,
  AddWebhookEndpointPayload,
} from 'api/admin/businesses/addWebhookEndpoint';

export const useAddWebhookEndpoint = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, AddWebhookEndpointPayload>({
    mutationFn: async ({ businessId, webhookEndpoint }) => {
      return addWebhookEndpoint({
        businessId,
        webhookEndpoint,
      });
    },
    onSuccess: async () => {
      toaster('Webhook Endpoint has been added', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while adding webhook endpoint', {
        icon: '❌',
      });
      return error;
    },
  });
};
